import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#multiple-selection" }),
  /*#__PURE__*/_createTextVNode(" Multiple Selection ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Set "),
  /*#__PURE__*/_createVNode("code", null, "props.multiple = true"),
  /*#__PURE__*/_createTextVNode(" to use multiple selection. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "block mb-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Display all tags (default)", -1)
const _hoisted_7 = { class: "block" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Collapse tags", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_cascader, {
          options: _ctx.options,
          props: _ctx.props,
          clearable: ""
        }, null, 8, ["options", "props"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_cascader, {
          options: _ctx.options,
          props: _ctx.props,
          "collapse-tags": "",
          clearable: ""
        }, null, 8, ["options", "props"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}